/* PreTech Park — blog index: tag filters, row titles decode on hover, the background word drifts with scroll,
   and the hero terminal types a `git log` of the latest entries (read from the log rows on the page). */
(function(){
  'use strict';
  var P=window.PTP,$=P.$,$$=P.$$,reduce=P.reduce;
  var rows=$$('.lr'),fb=$('#bfilt'),cnt=$('#bcount');
  if(fb)fb.addEventListener('click',function(e){var b=e.target.closest('button');if(!b)return;var k=b.getAttribute('data-k')||'',n=0;
    $$('button',fb).forEach(function(x){x.setAttribute('aria-pressed',x===b)});
    rows.forEach(function(r){var ok=!k||(' '+(r.getAttribute('data-k')||'')+' ').indexOf(' '+k+' ')>=0;r.classList.toggle('hide',!ok);if(ok)n++});
    if(cnt)cnt.textContent=('0'+n).slice(-2);P.frames()});
  rows.forEach(function(r){var b=r.querySelector('.lr__t b');if(b)r.addEventListener('mouseenter',function(){P.scramble(b,null,420)})});
  var w=$('.bg-hero .bgword');if(w&&!reduce)addEventListener('scroll',function(){w.style.setProperty('--bx',(-scrollY*.18)+'px')},{passive:true});
  /* terminal */
  var pre=$('#bterm');if(!pre)return;
  function esc(s){return String(s).replace(/[&<>]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;'}[c]})}
  var L=[['k','$ git log --oneline blog/']];
  /* each line is [class, already-escaped html] */
  if(rows.length)rows.slice(0,5).forEach(function(r){var de=r.querySelector('.lr__d'),tb=r.querySelector('.lr__t b'),d=de?de.textContent.trim():'',t=tb?(tb.getAttribute('data-text')||tb.textContent):'';
    L.push(['','<span class="c">'+esc(d)+'</span>  '+esc(t.length>34?t.slice(0,33)+'…':t)])});
  else L.push(['c','(no entries yet)']);
  L.push(['ok',rows.length?'✓ '+('0'+rows.length).slice(-2)+' entries on this page':'✓ first entries shipping soon']);
  function html1(l){return l[0]?'<span class="'+l[0]+'">'+(l[0]==='k'?esc(l[1]):l[1])+'</span>':l[1]}
  if(reduce){pre.innerHTML=L.map(html1).join('\n');return}
  function run(){var i=0,html='';pre.innerHTML='';
    (function line(){if(i>=L.length){setTimeout(run,6000);return}var l=L[i],full=html1(l);
      if(l[0]==='k'){var t=l[1],c=0;(function type(){c++;pre.innerHTML=html+'<span class="k">'+esc(t.slice(0,c))+'</span>';if(c<t.length)setTimeout(type,28);else{html+=full+'\n';i++;setTimeout(line,260)}})()}
      else{html+=full+'\n';pre.innerHTML=html;i++;setTimeout(line,170)}})()}
  run();
})();
